// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../sfd-v2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../sfd-v2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Vertical split layout owned by EpxDmn:
   editor area (top) + splitter + simulator dock (bottom). */

.epx-dmn {
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.epx-editor-area {
  flex: 1 1 auto;
  min-height: 120px;
  overflow: hidden;
  position: relative;
}

.epx-sim-splitter {
  flex: 0 0 6px;
  background: #1e293b;
  border-top: 1px solid #0b1220;
  border-bottom: 1px solid #0b1220;
  cursor: ns-resize;
  position: relative;
  user-select: none;
  display: none;
}
.epx-sim-splitter::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 36px;
  height: 2px;
  background: #475569;
  border-radius: 2px;
}
.epx-sim-splitter:hover { background: #334155; }
.epx-sim-splitter:hover::before { background: #64748b; }

.epx-sim-dock {
  flex: 0 0 45%;
  min-height: 120px;
  overflow: hidden;
  background: #0b1220;
  border-top: 1px solid #1e293b;
  display: none;
}

.epx-dmn.epx-sim-open .epx-sim-splitter { display: block; }
.epx-dmn.epx-sim-open .epx-sim-dock { display: flex; }
`, "",{"version":3,"sources":["webpack://./../epx-dmn/src/layout/dockStyles.css"],"names":[],"mappings":"AAAA;4DAC4D;;AAE5D;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AACA,0BAA0B,mBAAmB,EAAE;AAC/C,kCAAkC,mBAAmB,EAAE;;AAEvD;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;AACf;;AAEA,0CAA0C,cAAc,EAAE;AAC1D,sCAAsC,aAAa,EAAE","sourcesContent":["/* Vertical split layout owned by EpxDmn:\n   editor area (top) + splitter + simulator dock (bottom). */\n\n.epx-dmn {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n}\n\n.epx-editor-area {\n  flex: 1 1 auto;\n  min-height: 120px;\n  overflow: hidden;\n  position: relative;\n}\n\n.epx-sim-splitter {\n  flex: 0 0 6px;\n  background: #1e293b;\n  border-top: 1px solid #0b1220;\n  border-bottom: 1px solid #0b1220;\n  cursor: ns-resize;\n  position: relative;\n  user-select: none;\n  display: none;\n}\n.epx-sim-splitter::before {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 36px;\n  height: 2px;\n  background: #475569;\n  border-radius: 2px;\n}\n.epx-sim-splitter:hover { background: #334155; }\n.epx-sim-splitter:hover::before { background: #64748b; }\n\n.epx-sim-dock {\n  flex: 0 0 45%;\n  min-height: 120px;\n  overflow: hidden;\n  background: #0b1220;\n  border-top: 1px solid #1e293b;\n  display: none;\n}\n\n.epx-dmn.epx-sim-open .epx-sim-splitter { display: block; }\n.epx-dmn.epx-sim-open .epx-sim-dock { display: flex; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
